import jump from 'jump.js';

const JUMP_OFFSET = 300;

// scroll top
document.querySelectorAll('.link--top').forEach((link) => {
  link.addEventListener('click', (e) => {
    e.stopPropagation();
    e.preventDefault();
    jump(document.querySelector('html'), {
      offset: -JUMP_OFFSET,
      duration: 500,
    });
  });
});



// WEBPACK FOOTER //
// ./src/components/atoms/link/link.js